module.exports = __webpack_public_path__ + "media/images/logos/uca-8b4ad572aac131dd962441f4a15c49be.jpg";